import API from '../API.redux';
import { endpoints } from '../../config/endpoints';
import { joinUrlWithParams } from '../../utils';

import store from '../../redux/store';
import { userSelectors } from '../../redux/selectors';

export const getEndpoint = (which) => endpoints.selectors[which];

export const fetchSelectorsList = ({
  params,
  apiArgs = {},
}) => {
  const ENDPOINT = getEndpoint('list');

  const activeLanguage = userSelectors.activeLanguage(store.getState());
  const activeLocale = activeLanguage || 'pt-BR';

  return API(apiArgs)({
    url: joinUrlWithParams(ENDPOINT.url.replace(':locale', activeLocale), params),
    method: ENDPOINT.method,
  });
};
